// Manful engraving preview engine.
// The engraving is a sequence of tokens: { type:'text', value } and { type:'symbol', label, family, char }.
// Text is drawn in the chosen text font; each symbol is drawn inline in ITS OWN font, at the position
// the customer placed it. linesFromTokens() is pure (unit-tested); renderInline()/toPNG() are browser-only.

// Split a token stream into lines of atoms. A text token may contain '\n' (hard line breaks);
// a symbol token becomes a single atom carrying its own font. Pure + testable.
function linesFromTokens(tokens) {
  const lines = [[]];
  (tokens || []).forEach(t => {
    if (t.type === 'symbol') { lines[lines.length - 1].push({ symbol: t }); return; }
    const parts = String(t.value == null ? '' : t.value).split('\n');
    parts.forEach((p, i) => {
      if (i > 0) lines.push([]);
      if (p) lines[lines.length - 1].push({ text: p });
    });
  });
  return lines;
}

// Browser-only: lay the tokens out inline, centred, switching font per atom.
function renderInline(canvas, tokens, opts) {
  const ctx = canvas.getContext('2d');
  const W = opts.width, H = opts.height, fs = opts.fontSize;
  ctx.clearRect(0, 0, W, H);
  ctx.fillStyle = opts.color || '#1a1a1a';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'middle';
  const lines = linesFromTokens(tokens);
  const lineH = fs * 1.2;
  const startY = H / 2 - ((lines.length - 1) * lineH) / 2;
  const fontFor = a => `${fs}px "${a.symbol ? a.symbol.family : opts.textFont}"`;
  const textFor = a => (a.symbol ? (a.symbol.char || '') : a.text);
  lines.forEach((line, li) => {
    const widths = line.map(a => { ctx.font = fontFor(a); return ctx.measureText(textFor(a)).width; });
    const total = widths.reduce((s, w) => s + w, 0);
    let x = W / 2 - total / 2;
    const y = startY + li * lineH;
    line.forEach((a, i) => { ctx.font = fontFor(a); ctx.fillText(textFor(a), x, y); x += widths[i]; });
  });
  return lines;
}

// Export the canvas as a PNG Blob — kept for the future proof/mockup; not wired to the order in v1.
function toPNG(canvas) {
  return new Promise(res => canvas.toBlob(res, 'image/png'));
}

if (typeof module !== 'undefined' && module.exports) module.exports = { linesFromTokens, renderInline, toPNG };
else if (typeof window !== 'undefined') window.EngravingPreview = { linesFromTokens, renderInline, toPNG };
